import "bootstrap/dist/css/bootstrap.min.css";
import "./ConsultingServices.css";
import web from "../../../../Assets/Images/Services/Software Consulting/Web Development.svg";
import mobile from "../../../../Assets/Images/Services/Software Consulting/Mobile dev.svg";
import saas from "../../../../Assets/Images/Services/Software Consulting/Saas-svgrepo-com 1.svg";
import cloud from "../../../../Assets/Images/Services/Software Consulting/cloud-computing-data-svgrepo-com.svg";
import data from "../../../../Assets/Images/Services/Software Consulting/Data Analytics.svg";
import supply from "../../../../Assets/Images/Services/Software Consulting/supply-chain-Black icon.svg";
import inventory from "../../../../Assets/Images/Services/Software Consulting/Inventory-box-package-ultrathin-outline-svgrepo-com 1.svg";
import ecommerce from "../../../../Assets/Images/Services/Software Consulting/ecommerce-website-icon.svg";
import project from "../../../../Assets/Images/Services/Software Consulting/managament-manager-organize-svgrepo-com 1.svg";
import { Link } from "react-router-dom";

export const ConsultingServices = () => {
  return (
    <div id="services" className="services-container">
      <div className="services-title-btn text-center">
        <h1 className="services-title">Where Our Consulting Actually Helps</h1>
        <Link to="/contact-us">
          <button className="services-btn">Explore Consulting Services</button>
        </Link>
      </div>
      <div className="services-slider">
        <div className="services ss-1 d-flex">
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={web} alt="web consulting" className="" />
            <p>Web Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={mobile} alt="mobile consulting" className="" />
            <p>Mobile Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={saas} alt="web consulting" className="" />
            <p>Saas Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={cloud} alt="mobile consulting" className="" />
            <p>Cloud Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={data} alt="web consulting" className="" />
            <p>Data Analytics Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={supply} alt="mobile consulting" className="" />
            <p>Supply Chain Management Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={inventory} alt="web consulting" className="" />
            <p>Inventory Management Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={ecommerce} alt="mobile consulting" className="" />
            <p>Ecommerce Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={project} alt="web consulting" className="" />
            <p>Project Management Consulting</p>
          </div>
        </div>
        <div className="services ss-2 d-flex">
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={web} alt="web consulting" className="" />
            <p>Web Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={mobile} alt="mobile consulting" className="" />
            <p>Mobile Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={saas} alt="web consulting" className="" />
            <p>Saas Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={cloud} alt="mobile consulting" className="" />
            <p>Cloud Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={data} alt="web consulting" className="" />
            <p>Data Analytics Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={supply} alt="mobile consulting" className="" />
            <p>Supply Chain Management Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={inventory} alt="web consulting" className="" />
            <p>Inventory Management Consulting</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={ecommerce} alt="mobile consulting" className="" />
            <p>Ecommerce Consulting</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={project} alt="web consulting" className="" />
            <p>Project Management Consulting</p>
          </div>
        </div>
      </div>
    </div>
  );
};
